/**
 * Singleton-table hook (identity / voice_profile / visual_identity): one row per
 * (tenant, location_scope='all') in wizard v1. Field edits PATCH the existing row
 * or create it on first save; save fires on blur (contract §4.3 autosave-per-entry).
 */
import { useCallback } from 'react';
import { useBrandBibleWizardStore, selectEntries } from '@/stores/brandBibleWizardStore';
import type { BbPayloadMap, BbTable } from '@/features/brand-bible-wizard/types';

export function useSingleton<T extends BbTable>(table: T, tenantId: string) {
  const entries = useBrandBibleWizardStore(selectEntries(table));
  const upsertEntry = useBrandBibleWizardStore((s) => s.upsertEntry);
  const entry = entries.find((e) => e.location_scope === 'all' && e.deleted_at === null) ?? null;

  const save = useCallback(
    (patch: Partial<BbPayloadMap[T]>) => upsertEntry(table, patch, entry?.id, tenantId),
    [upsertEntry, table, entry?.id, tenantId],
  );

  return { entry, save };
}
